<template>
    <div>
        <p>Redirect in progress</p>
    </div>
</template>

<script>
import {userAuth} from '../services/security';
import store from '../store'


export default {
    async created() {
      var url = new URL(window.location);
      var params = url.searchParams;
      let page=params.get("page");
      let msg = params.get("msg");
      let type=params.get("type");

    if(page==="success")
     {
         msg="Thank you for the payment, order is being processed please check your email for details"
         type="info"
     }
    if(page==="error")
     {
       msg="Order was cancelled"
       type="warning"
     }
      if(msg!==null||page!==null)
      {
        if(type===null)
            type="info";
        let alertDetails= {msg:msg,type:type,display:true};
         store.dispatch('alertmessage/SetAlert',alertDetails)
         let returnToUrl = '/landing';
         window.location = returnToUrl;   
      }
      else
      await userAuth.CallBack();
    }
}
</script>